define('views/app/custom-head-style',[
    // Libs
    'underscore', 'backbone', 'mustache', 'color', 'utils',
    // services
    'services/app-state',
    // templates
    'text!templates/app/custom-head-style.css',

], function(
    // Libs
    _, Backbone, Mustache, Color, U,
    // services
    AppState,
    // templates
    TCustomHeadStyle
) {

    var VCustomHeadStyle = Backbone.View.extend({
        tagName: "style",
        template: TCustomHeadStyle,

        initialize: function(options) {
            options = options || {}; // additional options passed to the constructor.

            // TODO use the 'Color' lib to convert received color to hsl.

            _.extend(this, { colors: {} });

            Backbone.$('head').append(this.$el);

            this.listenTo(AppState, {
                "change:color": this.onColorChange,
            });
        },

        render: function() {
            // Render Template HTML with Mustache
            var html = Mustache.render(this.template, this.colors);
            this.$el.empty().append(html);

            return this;
        },

        capValue: function(value, limit, min) {
            return Boolean(min) === value >= limit ? value : limit;
        },

        updateColors: function(hue, saturation, lightness) {
            var c = this.colors = {
                    baseHue: hue,
                    baseSaturation: saturation,
                    baseLight: lightness,
                },
                capValue = this.capValue;

            _.extend(this.colors, {
                minLowLight: capValue(lightness, 40, true),
                minMedLight: capValue(lightness, 50, true),
                minGoodLight: capValue(lightness, 60, true),
                maxLowLight: capValue(lightness, 40),
                maxMedLight: capValue(lightness, 50),
                maxGoodLight: capValue(lightness, 60),
            });

        },

        onColorChange: function(model, color, options) {
            this.updateColors(color.hue() * 360, color.saturation() * 100, color.lightness() * 100);
            this.render();
        },

    });

    return VCustomHeadStyle;

});

